import { Conflict } from '../../hooks/conflicts/use-conflicts';
import { ItemConflict } from '../get-equipment-conflict';

interface CommonParams {
	conflict: Omit<Conflict<ItemConflict>, 'selectable'>;
}

interface ReservationParams extends CommonParams {
	rule: 'reservation';
	canOverrideReserved: boolean;
}

interface CheckoutParams extends CommonParams {
	rule: 'check-out';
	canOverrideCheckouts: boolean;
}

interface AssignToKitParams extends CommonParams {
	rule: 'assign-to-kit';
}

export function isItemSelectable(params: ReservationParams): boolean;
export function isItemSelectable(params: CheckoutParams): boolean;
export function isItemSelectable(params: AssignToKitParams): boolean;
export function isItemSelectable({
	conflict,
	...params
}: ReservationParams | CheckoutParams | AssignToKitParams): boolean {
	const isHardConflict = conflict.severity === 'hard';

	if (params.rule === 'reservation') {
		if (isHardConflict) return false;

		if (conflict.type !== ItemConflict.AVAILABLE) {
			return params.canOverrideReserved;
		}
	}

	if (params.rule === 'check-out') {
		if (isHardConflict) return false;

		if (conflict.type !== ItemConflict.AVAILABLE) {
			return params.canOverrideCheckouts;
		}
	}

	if (params.rule === 'assign-to-kit') {
		return !isHardConflict;
	}

	return true;
}
